import styled from "@emotion/styled";

const Wrapper = styled.div`
  background-color: ${p => p.theme.colors.background};
  border-radius: 12px;
  padding: 24px;
  height: 100%;
`;

const BoxIcon = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 60px;
`;

const BoxText = styled.div`
  color: ${p => p.theme.colors.secondary.gray};
`;

const Title = styled.h3`
  margin-bottom: 8px;
  font-size: 18px;
  font-weight: 500;
`;

const Text = styled.p`
  font-size: 14px;
  line-height: 1.5;
`;
export { Wrapper, BoxIcon, BoxText, Title, Text };
